import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
class MiniKPITrendline extends React.Component {
    constructor(props) {
        super(props);
          console.log(this.props.prams.filterData[this.props.prams.prams.kpiId]);
        this.state = {
        
          series: [{
            data: this.props.prams.filterData[this.props.prams.prams.kpiId]['data']
          }],
          options: {
            chart: {
              type: 'bar',
              height: 160,
              sparkline: {
                enabled: true
              },
            },
            stroke: {
              curve: 'straight'
            },
            fill: {
              opacity: 0.5
            },
            xaxis: {
              crosshairs: {
                width: 1
              },
            },
            yaxis: {
              min: 0
            },
            title: this.props.prams.filterData[this.props.prams.prams.kpiId]['title'],
            subtitle: this.props.prams.filterData[this.props.prams.prams.kpiId]['subtitle'],
          }
                
        
        
        };
      }
   

      render() {
        if(this.props.prams.filterData[this.props.prams.prams.kpiId]!=undefined){
            return (
              <div className='Polar'>
                <div className='row'>
                  <div className='col-lg-12'>
                    <div className='componentNameC'>{this.props.prams.prams.component}</div>
                  </div>
                </div>
                <div className="p-2 Polar1" >
                  <ReactApexChart options={this.state.options} series={this.state.series} type="area" height='90%' />
                </div>
              </div>
            );
          }else{
            return (
              <div className='Polar'>
                <div className='row'>
                  <div className='col-lg-12'>
                    <div className='componentNameC'>{this.props.prams.prams.component}</div>
                  </div>
                </div>
                <div className="p-4 Polar1" style={{   
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                height: '100vh', // Optionally set a height to center vertically in the viewport
                color: '#85929E'}}>
                  Data Not Found!
                    
                </div>
              </div>
            );
  }}
};

export default MiniKPITrendline;
